import PageContainer from "../components/pageContainer/PageContainer";
import SettingsLayout from "../components/settings/SettingsLayout";
import SettingsPageHeader from "../components/settings/SettingsPageHeader";
import Button from "../components/button";
import { Plus } from "../assets/icons";
import { useCallback, useEffect, useState } from "react";
import ApiDatabase from "../server";
import UseContext from "../hooks/useContext";
import useModal from "../components/modal/useModal";
import useTitle from "../hooks/TitleManager";
import TeamItem from "../components/teamItem/TeamItem";
import SettingsHelpBanner from "../components/settings/SettingsHelpBanner";

const SettingsTeam = () => {
  useTitle({ title: "Paramètres - Utilisateurs" });
  const {
    modalDataReturn,
    setModalDataReturn,
    teams,
    companySelected,
  } = UseContext();
  const { toggle } = useModal();
  const [companyTeams, setCompanyTeams] = useState([]);
  const [isWaiting, setIsWaiting] = useState(false);

  const fetchCompanyTeams = useCallback(() => {
    if (!companySelected?.idCompany) {
      setCompanyTeams([]);
      setIsWaiting(false);
      return;
    }
    setIsWaiting(true);
    ApiDatabase.getTeams(
      { companyId: companySelected.idCompany },
      (res) => {
        setCompanyTeams(res.teams || []);
        setIsWaiting(false);
      },
      (err) => {
        console.log("err", err);
        setCompanyTeams([]);
        setIsWaiting(false);
      },
    );
  }, [companySelected?.idCompany]);

  useEffect(() => {
    fetchCompanyTeams();
  }, [fetchCompanyTeams, teams]);

  const handleAddTeam = () => {
    toggle("add_team");
  };

  useEffect(() => {
    if (!modalDataReturn?.employees) return;
    setModalDataReturn({});
    fetchCompanyTeams();
  }, [modalDataReturn, setModalDataReturn, fetchCompanyTeams]);

  return (
    <PageContainer type={"settings_team"}>
      <div className="flex w-full max-w-[1122px] flex-col gap-6">
        <div className="grid grid-cols-1 gap-8 pt-6 lg:grid-cols-[minmax(0,1fr)_minmax(400px,440px)] lg:items-stretch">
          <SettingsLayout withTopPadding={false} innerScroll={false}>
            <div className="flex flex-col gap-6">
          <SettingsPageHeader
            title="Utilisateurs"
            action={
              <Button color={"PRIMARY"} size={"SM"} onClick={handleAddTeam}>
                <div className={"flex gap-1 items-center"}>
                  <Plus wh={20} color={"#FFFFFF"} />
                  <span>Inviter un utilisateur</span>
                </div>
              </Button>
            }
          />

          <section className="flex flex-col">
            <div className={"grid grid-cols-5 border-b border-gray-100 p-4 text-sm"}>
              <div className={"col-span-3"}>
                UTILISATEURS{!isWaiting && ` (${companyTeams.length})`}
              </div>
              <div className={"text-gray-500"}>RÔLE</div>
            </div>
            {isWaiting
              ? [1, 2, 3, 4].map((index) => (
                  <div
                    key={index}
                    className={
                      "grid grid-cols-5 animate-pulse border-b border-gray-100 p-4 text-sm"
                    }
                  >
                    <div className={"col-span-3"}>
                      <div className={"flex gap-6"}>
                        <div className={"h-10 w-10 rounded bg-gray-200"}></div>
                        <div className={"flex flex-col gap-1"}>
                          <div className={"h-4 w-32 rounded bg-gray-200"}></div>
                          <div className={"h-4 w-40 rounded bg-gray-200"}></div>
                        </div>
                      </div>
                    </div>
                    <div className={"flex items-center"}>
                      <div className={"h-4 w-40 rounded bg-gray-200"}></div>
                    </div>
                    <div className={"flex items-center justify-end"}>
                      <div className={"h-8 w-8 rounded bg-gray-200"}></div>
                    </div>
                  </div>
                ))
              : companyTeams.length > 0 &&
                companyTeams.map((team, index) => (
                  <TeamItem team={team} key={index} />
                ))}
          </section>
        </div>
          </SettingsLayout>

          <aside className="hidden min-w-0 lg:block">
            <div>
              <SettingsHelpBanner
                title="Qu'est-ce qu'un utilisateur ?"
                description="Un utilisateur est une personne habilitée à administrer l'application Workfully au quotidien : gestion des shifts, exports d'heures, modification des pointages, etc."
              />
            </div>
          </aside>
        </div>
      </div>
    </PageContainer>
  );
};

export default SettingsTeam;
